import React from 'react';

const Checkbox = ({ checked, onChange, label }) => {
    return (
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
                type="checkbox"
                checked={checked}
                onChange={onChange}
            />
            <span>{label}</span>
        </label>
    );
};


export default Checkbox;
